<template>
  <div class="card">
    <div class="card-content">
      <question-title :question="question" class="mb1"></question-title>

      <div class="control mt1">
        <input
          class="input"
          type="text"
          :value="choice"
          @input="recordAnswer"
        />
      </div>

      <next-button :id="question.id" :choice="choice"></next-button>
    </div>
  </div>
</template>

<script>
import baseQuestion from "./baseQuestion";

export default {
  name: "singleText",

  mixins: [baseQuestion],

  methods: {
    recordAnswer(e) {
      const text = e.target.value;
      if (text.length) {
        this.choice = text;
        this.$store.dispatch("interview/setNext", true);
      }
    }
  }
};
</script>
